import { useLocation } from '../../context/LocationContext';
import { useKdsExpo } from '../../hooks/useKdsExpo';
import { sortExpoOrders } from './selectors';
import { useKdsBoard, type NavItem } from './useKdsBoard';
import BoardLayout from './BoardLayout';
import ExpoBoard from './board/ExpoBoard';
import SidePanel from './panels/SidePanel';
import OrderDetailSheet from './panels/OrderDetailSheet';
import ItemTotalsPanel from './panels/ItemTotalsPanel';

/** Expo view: every station's open tasks rolled up per Order, with the order detail + item totals. */
const ExpoBoardPage = () => {
  const { location } = useLocation();
  const { data: expoView, isPending } = useKdsExpo(location.id);

  const orders = sortExpoOrders(expoView?.orders ?? []);
  const itemTotals = expoView?.itemTotals ?? [];

  // One nav entry per Order (a whole card), with no inline action — Enter opens its detail.
  const navItems: NavItem[] = orders
    .filter((order) => order.groupId)
    .map((order) => ({ cardId: order.groupId, groupId: order.groupId }));

  const board = useKdsBoard(navItems);

  const order = board.detailOpen ? orders.find((o) => o.groupId === board.selectedGroupId) : undefined;

  return (
    <BoardLayout
      loading={board.stationsPending || isPending}
      stations={board.sortedStations}
      selection={{ kind: 'expo' }}
      onSelectStation={board.onSelectStation}
      connectionState={board.connectionState}
      recentOpen={board.auxOpen}
      onToggleRecent={board.onToggleRecent}
      onBoardClick={board.deselectOnOutsideClick}
      board={
        <ExpoBoard
          orders={orders}
          stationNameById={board.stationNameById}
          selectedGroupId={board.selectedGroupId}
          focusedCardId={board.focusedCardId}
          onOpenDetail={board.openDetail}
        />
      }
      detail={
        order && (
          <SidePanel variant="detail" docked={board.isDesktop}>
            <OrderDetailSheet
              bookingOrderId={order.bookingOrderId}
              createdUtc={order.createdUtc}
              orderComment={order.orderComment}
              displayItems={order.displayItems}
              stationNameById={board.stationNameById}
              onClose={board.closeDetail}
            />
          </SidePanel>
        )
      }
      aux={
        board.auxOpen && (
          <SidePanel variant="aux" docked>
            <ItemTotalsPanel itemTotals={itemTotals} showClose={!board.isDesktop} onClose={board.closeAux} />
          </SidePanel>
        )
      }
    />
  );
};

export default ExpoBoardPage;
